import { gql } from "@apollo/client";

const UPLOAD_KNOWLEDGE_SOURCE = gql`
  mutation UploadKnowledgeSource($input: UploadKnowledgeInput!) {
    uploadKnowledgeSource(input: $input) {
      success
      error
      source {
        id
        sourceId
        botId
        sourceType
        sourceName
        status
        totalChunks
        createdAt
      }
    }
  }
`;

export default UPLOAD_KNOWLEDGE_SOURCE;
